import { css } from "@stubhub/broadway-foundation/css";

/** 38px has no spacing token — between primitives.400 (32px) and primitives.500 (40px) */
export const favButtonWithCountStyle = css({
  height: "[38px]",
  minWidth: "[38px]",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
